/**
* @file 战队-战队仓库
* @author 余凯
*/

import React from 'react'
import { Table, Divider, Tag } from 'antd';
import './index.less'

import { connect } from 'react-redux'
import Actions from '@/apis/team'

const columns = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key',
    render: text => <a>{text}</a>,
  },
  {
    title: '道具名称',
    dataIndex: 'item_name',
    key: 'item_name',
  },
  {
    title: '道具数量',
    dataIndex: 'item_count',
    key: 'item_count',
  },
  // {
  //   title: '发放时间',
  //   dataIndex: 'age',
  //   key: 'age',
  // },
  // {
  //   title: '领取时间',
  //   dataIndex: 'address',
  //   key: 'address',
  // },
  // {
  //   title: '领取状态',
  //   key: 'tags',
  //   dataIndex: 'tags',
  //   render: tag => {
  //     let color = 'geekblue'
  //     if (tag === '已领取') {
  //       color = '';
  //     }
  //     return (
  //       <Tag color={color} key={tag}>
  //         {tag.toUpperCase()}
  //       </Tag>
  //     );
  //   },
  // },
];

@connect(
  state => state.teamReducer,
)
class RewardCollection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      own: 0,
      goodsList: []
    }
  }

  componentDidMount() {
    this.getGoodsList()
  }

  getGoodsList = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
    }
    const res = await Actions.getTeamGoodsList(params)
    if (res.code == 200) {
      this.setState({
        goodsList: res.data.map((v, i) => ({ ...v, key: i + 1 }))
      })
    }
  }

  render() {
    const { goodsList } = this.state
    return (
      <div className="reward_collection" id="reward_collection">
        <h3>战队仓库</h3>
        <Table
          size="small"
          columns={columns}
          dataSource={goodsList}
        />
      </div>
    );
  }
}

export default RewardCollection;
